export default "__VITE_ASSET__5kEgvn3m__"